export default __webpack_public_path__ + "static/media/pacModal.23978d47.png";